module.exports = __webpack_public_path__ + "img/icon_processing_status.aa271fb1.png";